module.exports = __webpack_public_path__ + "img/Alex_Swensen.fefb5f55.png";